import { t } from '@lingui/macro';
import React from 'react';

import {
    ErrorContainer, ErrorLogo, ErrorText
} from './error-message.styled';

export type MessageProps = {
    errorCode: number | null
};

export const ErrorMessage = ({ errorCode }: MessageProps) => {
    return (
        <>
            <ErrorContainer>
                <ErrorLogo
                    src={'../../../assets/icons/icon_error.svg'}
                    alt={'Error Message'}
                />
                <ErrorText data-testid={'error-message'}>
                    { errorCode === 101 ?
                        // eslint-disable-next-line @typescript-eslint/naming-convention
                        <div dangerouslySetInnerHTML={{ __html: t`errorMessage.text1` }} />
                        // eslint-disable-next-line @typescript-eslint/naming-convention
                        : <div dangerouslySetInnerHTML={{ __html: t`errorMessage.text2` }} />
                    }
                </ErrorText>
            </ErrorContainer>
        </>
    );
};
